import { actionConstants } from './actionConstants';
import { get, post } from './method';
import noti from './toast';

export const dashboardActions = {
  getAlarmList,
  getMobileAlarmListByMC,
  getAvailableGroups,
  getAvailableGroupsSummaries,
  addNote,
  getTrend,
  getTrendV2,
};

function getAlarmList() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/dashboard/alerts')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_LIST_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
       // noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_LIST_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getMobileAlarmListByMC(mobileConfigId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    if (mobileConfigId) {
      return await get(
        `app/sensors/alarmStatus/by-mobileConfig/${mobileConfigId}`,
      )
        .then((resp) => {
          dispatch({
            type: actionConstants.GET_ALARM_LIST_BY_MC_SUCCESS,
            data: resp,
          });
        })
        .catch((error) => {
          noti.error(error.response.data.error.message);
          dispatch({
            type: actionConstants.GET_ALARM_LIST_BY_MC_FAILURE,
            data: error.response.data.error.message,
          });
          throw error.response.data.error.message;
        });
    } else {
      return await get(`app/sensors/alarmStatus/current-user`)
        .then((resp) => {
          dispatch({
            type: actionConstants.GET_ALARM_LIST_BY_MC_SUCCESS,
            data: resp,
          });
        })
        .catch((error) => {
          noti.error(error.response.data.error.message);
          dispatch({
            type: actionConstants.GET_ALARM_LIST_BY_MC_FAILURE,
            data: error.response.data.error.message,
          });
          throw error.response.data.error.message;
        });
    }
  };
}

function getAvailableGroups() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/dashboard/alertGroupSummaries?MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_AVAILABLE_GROUPS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_AVAILABLE_GROUPS_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getAvailableGroupsSummaries(groupId) {
  return async (dispatch) => {
    return await get(`app/dashboard/alertGroupSummaries/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_AVAILABLE_GROUPS_SUMMARIES_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_AVAILABLE_GROUPS_SUMMARIES_FAILURE,
          data: error,
        });
        throw error.response.data.error.message;
      });
  };
}

function addNote(_params, isLast) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/notes', params)
      .then((resp) => {
        noti.success(`Note is added`);
        dispatch({
          type: actionConstants.ADD_NOTE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .then(() => {
        if (isLast) {
          return true;
        } else return false;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.ADD_NOTE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function getTrend(sensorIds, fromDate, toDate) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(
      `app/dashboard/trendCharts?SensorIds=${sensorIds}&FromDate=${fromDate}&ToDate=${toDate}`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_TREND_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_TREND_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

async function getTrendV2(sensorIds, fromDate, toDate) {
  return await get(
    `app/dashboard/trendCharts?SensorIds=${sensorIds}&FromDate=${fromDate}&ToDate=${toDate}`,
  );
}
